import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { OrderApi } from '@/entities/order/api';
import {
  clearLastOrderContext,
  flagOpenCartOnNextLoad,
  getLastOrderId,
  getLastRestaurantId,
} from '@/entities/order/lib/orderStorage';
import { StatusModal } from '@/features/orders/ui/OrderPaymentStatus/StatusModal';
import { ROUTES } from '@/shared/constants/routes';

export const PaymentFailPage: React.FC = () => {
  const navigate = useNavigate();

  const goBackToRestaurantWithCart = () => {
    const rid = getLastRestaurantId();

    clearLastOrderContext();
    flagOpenCartOnNextLoad();

    navigate(rid ? ROUTES.restaurant(rid) : ROUTES.home(), { replace: true });
  };

  useEffect(() => {
    const oid = getLastOrderId();
    if (oid) {
      OrderApi.failPayment(Number(oid)).catch(() => {});
    }
  }, []);

  return (
    <>
      <title>Проблема с оплатой — Order2Go.ru</title>
      <StatusModal
        image="error"
        open
        onClose={goBackToRestaurantWithCart}
        headerText="Не удалось принять заказ"
        title="Оплата не прошла"
        subtitle="Не удалось оплатить заказ. Попробуйте снова"
        btnText="Понятно"
        onAction={goBackToRestaurantWithCart}
      />
    </>
  );
};

export default PaymentFailPage;
